import type { File } from "app/util/workspace";
export interface Input {
  files: File[];
  filesChange?: (files: File[]) => void;
}

let/tab=0

split-panes
  @first
    editor files:=input.files tab:=tab
  @second
    result files=input.files selected=tab
